import React from 'react';
import { choose } from '../../utils/platform';
import { useUsers } from './useUsers';
import UsersDesktop from './Users.desktop';
import UsersMobile from './Users.mobile';
import '../../styles/people.css';

const UsersView = choose(UsersDesktop, UsersMobile);

export default function Users() {
  const vm = useUsers();
  if (!vm.canViewUsers) {
    return (
      <div>
        <div className="page-head"><h1>Members</h1></div>
        <div className="card card-pad empty">You don't have access to add members. Ask an Event Admin to grant it.</div>
      </div>
    );
  }
  return <UsersView vm={vm} />;
}
